import React from 'react';
import { useAndroidDetection } from '../../hooks/useAndroidDetection';
import './Footer.css';

const Footer: React.FC = () => {
  const isAndroid = useAndroidDetection();

  const handleDownload = () => {
    window.open('https://play.google.com/store/apps/details?id=com.sssk.justfun', '_blank');
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'JustFun - Brain Training Games',
        text: 'Check out these awesome puzzle games!',
        url: window.location.href
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>🎮 JustFun</h3>
          <p>Brain training games for everyone</p>
        </div>
        
        <div className="footer-section">
          <h4>Games</h4>
          <ul>
            <li>8-Puzzle</li>
            <li>Sudoku</li>
            <li>Tic-Tac-Toe</li>
            <li>Memory Game</li>
            <li>Word Puzzle</li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Get the App</h4>
          {isAndroid ? (
            <div className="android-download">
              <button onClick={handleDownload} className="download-button">
                📱 Download Android App
              </button>
              <p>Get rewards, achievements, and more!</p>
            </div>
          ) : (
            <div className="other-platforms">
              <p>Android app available</p>
              <button onClick={handleDownload} className="download-button">
                📱 View on Play Store
              </button>
            </div>
          )}
        </div>
        
        <div className="footer-section">
          <h4>Share</h4>
          <button onClick={handleShare} className="share-button">
            📤 Share Games
          </button>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 JustFun. All rights reserved.</p>
        <p>Made with ❤️ for brain training enthusiasts</p>
      </div>
    </footer>
  );
};

export default Footer;
